import theme from "../../theme";
import type { MainContainerStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<MainContainerStyles, SxProps<Theme>> => {
  return {
    avatar: {
      m: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },

    paper: {
      padding: theme.spacing(2, 4),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      position: "relative",
      paddingBottom: theme.spacing(10),
    },

    title: {
      mb: theme.spacing(5),
      textAlign: "center",
    },
  };
};

export default getStyles;
